// Chat widget constants — extracted to avoid magic numbers.
export const MAX_USER_TURNS = 3; // service → name → requirement
export const SCROLL_REVEAL_THRESHOLD = 300;

/**
 * Build the WhatsApp handoff message from the 3 collected user turns:
 *   turn 1 = service, turn 2 = name, turn 3 = requirement.
 * Falls back gracefully if the sequence is shorter than 3.
 */
export const buildHandoffMessage = (messages) => {
  const userMsgs = messages.filter((m) => m.role === 'user').map((m) => m.content.trim());
  const [service, name, requirement] = [userMsgs[0] || '', userMsgs[1] || '', userMsgs[2] || ''];

  const lines = ['Namaste Nitika Ji, I came from your website.', ''];
  if (name) lines.push(`Name: ${name}`);
  if (service) lines.push(`Service: ${service}`);
  if (requirement) lines.push(`Requirement: ${requirement}`);
  lines.push('', 'Please guide me further.');
  return lines.join('\n');
};

export const countUserTurns = (messages) =>
  messages.filter((m) => m.role === 'user').length;
